var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMessageIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\xFCzenet_ikon",
    transform: "translate(-1765.505 -601.197)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16823"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10864",
    d: "M1792.005,632.2h-22a4.506,4.506,0,0,1-4.5-4.5v-22a4.5,4.5,0,0,1,4.5-4.5h22a4.5,4.5,0,0,1,4.5,4.5v22A4.5,4.5,0,0,1,1792.005,632.2Zm-22-30a3.5,3.5,0,0,0-3.5,3.5v22a3.5,3.5,0,0,0,3.5,3.5h22a3.5,3.5,0,0,0,3.5-3.5v-22a3.5,3.5,0,0,0-3.5-3.5Z",
    fill: "#929ea7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_16824"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10865",
    d: "M1790.065,606.7h-18.39a1.873,1.873,0,0,0-1.87,1.87v13.3a1.867,1.867,0,0,0,1.87,1.87h13.75l4.44,4.38-.03-4.38h.23a1.867,1.867,0,0,0,1.87-1.87v-13.3A1.873,1.873,0,0,0,1790.065,606.7Zm-14.86,10.349a1.57,1.57,0,1,1,1.57-1.57A1.566,1.566,0,0,1,1775.2,617.046Zm5.39,0a1.57,1.57,0,1,1,1.58-1.57A1.572,1.572,0,0,1,1780.595,617.046Zm5.96-3.139a1.57,1.57,0,1,1-1.57,1.569A1.574,1.574,0,0,1,1786.555,613.907Z",
    fill: "#929ea7"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageIcon);
export default __webpack_public_path__ + "static/media/messageIcon.69eb1d8af71c968f255d40fdab54d808.svg";
export { ForwardRef as ReactComponent };